import { ApplicationController } from "../application_controller";

// Nested tabs (the service types of a deal) become an accordion on phones and tablets: the pills are hidden,
// every pane gets a header with the icon and the name of its tab link plus a summary, a tap opens the pane.
// The summary is the data-mobile-summary attribute of an element inside the pane (it may come later with the
// loaded content); a pane without it is marked with data-layout--mobileAccordion-empty-text.
// Put it on the element that holds both the .nav-pills list and the .tab-content.
export default class extends ApplicationController {
  connect() {
    this.element.classList.add("mobile-accordion");
    this.headers = [];
    this.observers = [];
    this.links().forEach(link => this.addHeader(link));
  }

  disconnect() {
    this.observers.forEach(observer => observer.disconnect());
    this.headers.forEach(header => header.remove());
  }

  links() {
    return Array.from(this.element.querySelectorAll(".nav-pills .nav-link[href^='#']"));
  }

  addHeader(link) {
    const pane = this.element.querySelector(link.getAttribute("href"));
    if (!pane) return;

    const header = document.createElement("button");
    header.type = "button";
    header.className = "mobile-accordion__header d-lg-none";
    header.setAttribute("aria-expanded", "false");
    header.innerHTML = "<span class='mobile-accordion__title'></span><span class='mobile-accordion__summary'></span>" +
      "<i class='fas fa-chevron-down mobile-accordion__chevron'></i>";
    // the icon and the name as the server rendered them in the tab link
    header.querySelector(".mobile-accordion__title").innerHTML = link.innerHTML;
    header.addEventListener("click", () => this.toggle(pane, header));
    pane.parentNode.insertBefore(header, pane);
    this.headers.push(header);

    this.updateSummary(pane, header);
    const observer = new MutationObserver(() => this.updateSummary(pane, header));
    observer.observe(pane, { childList: true, subtree: true });
    this.observers.push(observer);
  }

  toggle(pane, header) {
    const open = pane.classList.toggle("mobile-accordion__pane--open");
    header.setAttribute("aria-expanded", String(open));
  }

  // until the pane content is loaded there is no summary; an empty pane shows the .info-card placeholder
  updateSummary(pane, header) {
    const marker = pane.querySelector("[data-mobile-summary]");
    const empty = !marker && pane.querySelector(".info-card") !== null;
    const summary = header.querySelector(".mobile-accordion__summary");
    let text = "";
    if (marker) text = marker.dataset.mobileSummary;
    else if (empty) text = this.data.get("empty-text") || "";

    if (summary.textContent !== text) summary.textContent = text;
    header.classList.toggle("is-empty", empty);
  }
}
